var FooterDataTestIdEnum = /* @__PURE__ */ ((FooterDataTestIdEnum2) => {
  FooterDataTestIdEnum2["FOOTER_FOR_YOU_SECTION"] = "for-you-section";
  FooterDataTestIdEnum2["FOOTER_FOR_PROFESSIONALS_AND_CLINICS_SECTION"] = "for-professionals-and-clinics-section";
  FooterDataTestIdEnum2["FOOTER_DOWNLOAD_APP_SECTION"] = "download-app-section";
  FooterDataTestIdEnum2["FOOTER_ABOUT_SECTION"] = "about-section";
  FooterDataTestIdEnum2["FOOTER_INSTAGRAM_LINK"] = "instagram-link";
  FooterDataTestIdEnum2["FOOTER_FACEBOOK_LINK"] = "facebook-link";
  FooterDataTestIdEnum2["FOOTER_RESERVED"] = "reserved-footer";
  FooterDataTestIdEnum2["FOOTER_CONTENT"] = "footer-content";
  FooterDataTestIdEnum2["FOOTER_PAYMENT_INFO"] = "payment-info";
  FooterDataTestIdEnum2["FOOTER_IOS_LINK"] = "ios-link";
  FooterDataTestIdEnum2["FOOTER_ANDROID_LINK"] = "android-link";
  FooterDataTestIdEnum2["FOOTER_MOCK_ITEM"] = "mock-item";
  FooterDataTestIdEnum2["FOOTER_MOCK_ITEM_LIST"] = "mock-item-list";
  FooterDataTestIdEnum2["FOOTER_MOCK_BLAME_HERE"] = "mock-blame-here";
  FooterDataTestIdEnum2["FOOTER_MOCK_DOWNLOAD_APP"] = "mock-download-app";
  FooterDataTestIdEnum2["FOOTER_MOCK_OUR_NETWORK"] = "mock-our-network";
  FooterDataTestIdEnum2["FOOTER_MOCK_ACCORDION"] = "mock-accordion";
  FooterDataTestIdEnum2["FOOTER_MOCK_ITEM_TITLE"] = "mock-footer-item-title";
  FooterDataTestIdEnum2["FOOTER_MOCK_IMAGE"] = "mock-image";
  return FooterDataTestIdEnum2;
})(FooterDataTestIdEnum || {});
export {
  FooterDataTestIdEnum
};
